"use client";

import React, { Fragment, useMemo } from "react";

import "@/app/globals.css";

import withBrand from "@/components/with-brand";
import useMediaQuery from "@/hooks/use-media-query/use-media-query-enhanced";
import { BrandKey } from "@/types/common-types";

import SingleItem from "./single-item";

function InterstitialPageContent({
  listItemContent,
  setComplete,
  brand = "staysure",
}: Readonly<{
  listItemContent?: {
    title: string;
    mobileContent: string[];
    desktopContent: string[];
  };
  brand?: BrandKey;
  setComplete: (val: boolean) => void;
}>) {
  const [lastCompletedIndex, setLastCompletedIndex] = React.useState(0);
  const [isTabOrDesktop, isReady] = useMediaQuery("(min-width: 600px)");
  const { title } = listItemContent || { title: "" };

  const listItems = useMemo(() => {
    if (listItemContent) {
      return isTabOrDesktop
        ? listItemContent.desktopContent
        : listItemContent.mobileContent;
    }
    return [];
  }, [listItemContent, isTabOrDesktop]);

  const animationPath = useMemo(() => {
    if (brand === "avanti") return "/images/renewals/renewals-landing-avn.gif";

    return "/images/renewals/renewals-landing-sts.gif";
  }, [brand]);

  if (!isReady) return null;

  if (lastCompletedIndex === listItems?.length) {
    setComplete(true);
  }

  return (
    <div className="lg:pt-spacing-xl lg:pb-spacing-xxl md:pb-spacing-6xl md:pt-[0] px-spacing-m md:px-[0px] lg:min-h-[640px] md:min-h-[899px] min-h-[688px] md:flex md:items-center lg:block">
      <div className="w-fit mx-auto h-fit">
        <div className="w-fit mx-auto h-[200px]">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={animationPath}
            alt="landing-animation"
            className="w-[200px] h-[200px] text-transparent"
            role="presentation"
            aria-hidden="true"
          />
        </div>
        <header className="lg:my-spacing-xl mt-spacing-m mb-spacing-l md:my-spacing-l font-[400] md:leading-[45px] md:text-5xl leading-[29.9px] text-xl font-header-font text-dark-text-title text-center">
          {title}
        </header>
        <div className="w-full">
          <div className="mx-auto w-fit">
            {listItems?.map((item, index) => (
              <Fragment key={index as unknown as string}>
                <SingleItem
                  brand={brand}
                  text={item}
                  isLast={index === (listItems ? listItems.length : 0) - 1}
                  index={index + 1}
                  isAnimatingStart={lastCompletedIndex === index}
                  onComplete={(indexNo) => setLastCompletedIndex(indexNo)}
                />
              </Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default withBrand(InterstitialPageContent);
